// service/Familiares.js
import instance from "../apis/app";
import { errorDeApi } from "./client";

const List = async () => {
    try {
        const response = await instance.get('/familiares');
        return response.data;
    } catch (error) {
        throw errorDeApi(error);
    }
};

const Get = async (id) => {
    try {
        const response = await instance.get(`/familiar/${id}`);
        return response.data;
    } catch (error) {
        throw errorDeApi(error);
    }
};

const Create = async (data) => {
    try {
        const response = await instance.post('/familiar', data);
        return response.data;
    } catch (error) {
        throw errorDeApi(error);
    }
};

const Update = async (id, data) => {
    try {
        const response = await instance.put(`/familiar/${id}`, data);
        return response.data;
    } catch (error) {
        throw errorDeApi(error);
    }
};

const Delete = async (id) => {
    try {
        const response = await instance.delete(`/familiar/${id}`);
        return response.data;
    } catch (error) {
        throw errorDeApi(error);
    }
};

const ValidarEdad = async (familiarId, tallerId) => {
    try {
        const response = await instance.get(`/familiar/${familiarId}/validar-edad/${tallerId}`);
        return response.data;
    } catch (error) {
        throw errorDeApi(error);
    }
};

// ✨ NUEVO: Buscar familiares por RUT o nombre
const BuscarPorRutONombre = async (query) => {
    try {
        const response = await instance.get('/familiares/buscar', {
            params: { query }
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// ✨ NUEVO: Obtener familiares de un usuario específico
const ObtenerPorUsuario = async (cognitoId) => {
    try {
        const response = await instance.get(`/familiares/usuario/${cognitoId}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Hard delete de familiar por admin (sin validar ownership)
const AdminDelete = async (id) => {
    try {
        const response = await instance.delete(`/admin/familiar/${id}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export default {
    List,
    Get,
    Create,
    Update,
    Delete,
    ValidarEdad,
    BuscarPorRutONombre,
    ObtenerPorUsuario,
    AdminDelete,
};
